<mat-sidenav-container class="reservation-detail-component">
  <mat-sidenav #clientSideNav [fixedInViewport]="false" position="end">
    <app-new-contact-sidenav
      (close)="clientCloseClicked($event)"
      [contact]="sideNavContact"
      [reservationId]="this.form.get('reservation')?.get('id')?.value"
      [wineryId]="companyId"
      [isTourOperator]="
        isTourOperator && sideNavContact?.contactType != 'SECONDARY'
      "
    ></app-new-contact-sidenav>
  </mat-sidenav>

  <mat-sidenav-content
    [ngStyle]="{ height: 'auto' }"
    style="overflow-y: auto !important"
    [formGroup]="form"
  >
    <div class="ws-popup-header">
      <div class="reservation-title" *ngIf="reservation">
        <div class="reservation-title-ref">ID:</div>
        <div class="reservation-title-id">{{ reservation?.id }}</div>
        <span class="seatsLabel" *ngIf="countForExperience"
          >{{ "Posti Disponibili" | translate }}:
          {{ countForExperience!.availableSeats }} (
          {{ countForExperience!.occupiedCount }}/{{
            countForExperience!.maxParties
          }}
          )</span
        >
      </div>

      <div *ngIf="!reservation" class="reservation-title">
        {{ "New reservation" | translate }}
      </div>

      <div *ngIf="isGift || giftAssociatedBeforeRevocation" class="gift">
        gift <i class="icon-gift-box-open"></i>
      </div>
      <div
        *ngIf="
          (isGift && (!reservation || !byGift)) ||
          giftAssociatedBeforeRevocation
        "
        class="gift-linked"
      >
        <span (click)="openGiftDialog()" class="link-gift">{{
          "Open gift details" | translate
        }}</span>
      </div>
      <div class="actions">
        <ws-button
          (click)="returnToGift()"
          *ngIf="reservation && byGift"
        >
          <mat-icon>arrow_back_ios_new</mat-icon>
        </ws-button>
        <button
          [matMenuTriggerFor]="moreOptions"
          *ngIf="reservation"
          mat-icon-button
        >
          <mat-icon>more_vert</mat-icon>
        </button>
        <button class="close-button" mat-icon-button (click)="cancelClicked()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <mat-menu #moreOptions="matMenu" xPosition="before">
      <button (click)="cloneReservationClicked()" mat-menu-item *ngIf="!byGift">
        <mat-icon>content_copy</mat-icon>
        {{ "Duplicate" | translate }}
      </button>
      <web-reservation-additional-questions-action
        *ngIf="reservation?.id"
        [reservationId]="reservation.id"
        display="menu"
      ></web-reservation-additional-questions-action>
      <!-- <button
        (click)="syncReservationClicked($event)"
        mat-menu-item
        *ngIf="this.reservation?.state !== 'waiting'"
      >
        <mat-icon [ngClass]="{ spinning: isSyncingInBackground }">sync</mat-icon>
        {{ "Sync external calendar" | translate }}
      </button> -->
      <web-external-sync-button
        *ngIf="this.reservation?.state !== 'waiting'"
        [label]="'Sync external calendar' | translate"
        [actionObservable]="externalCalendarSync$"
      ></web-external-sync-button>
      <button
        (click)="generatePaymentLinkClicked($event)"
        *ngIf="showGeneratePaymentLink()"
        mat-menu-item
        [disabled]="
          isCreatingPaymentLink ||
          !stripeConnected ||
          remainingDueCents() <= 0
        "
      >
        <mat-icon>link</mat-icon>
        {{
          (isCreatingPaymentLink ? "Creating" : "Generate Payment Link")
            | translate
        }}
      </button>
      <button
        (click)="openPaymentLinkDialog()"
        *ngIf="showPaymentLinkAction()"
        mat-menu-item
      >
        <mat-icon>link</mat-icon>
        {{ "Payment Link" | translate }}
      </button>
      <button
        (click)="openAvailabilityAutomationDialog()"
        *ngIf="reservation && reservation.state == 'confirmed'"
        mat-menu-item
      >
        <mat-icon *ngIf="isAvailabilityBlock">lock_open</mat-icon>
        <mat-icon *ngIf="!isAvailabilityBlock">lock</mat-icon>
        {{ "Availability Automation" | translate }}
      </button>

      <web-external-sync-button
        *ngFor="let button of visibleSyncButtons"
        [label]="button.label | translate"
        [matIconName]="button.icon"
        [successMessage]="button.successMessage | translate"
        [errorMessage]="button.errorMessage | translate"
        [actionObservable]="button.actionObservable"
        [statusObservable]="button.statusObservable"
        [hideWhenStatus]="button.id === 'force-create-receipt'"
      ></web-external-sync-button>
      <button
        (click)="addInvoiceData()"
        *ngIf="isManualReservation && !isInvoiceDataReadOnly"
        mat-menu-item
      >
        <mat-icon>receipt_long</mat-icon>
        {{
          (invoiceKeys.length > 0 ? "Edit invoice data" : "Add invoice data")
            | translate
        }}
      </button>

      <!--<button
          (click)="generateWineLensLinkClicked()"
          mat-menu-item
          *ngIf="reservation && reservation.state == 'confirmed'"
        >
            <mat-icon>qr_code</mat-icon>
            {{ "Generate Wine Lens link" | translate }}
        </button>-->

      <!--
      <span
        wsTooltip="Transactional emails not present due to participant's email address not being present"
        [wsTooltipDisabled]="!!masterContactControl?.get('email')?.value"
      >
        <button
          (click)="manageEmailSending()"
          mat-menu-item
          [disabled]="!masterContactControl?.get('email')?.value"
        >
          <mat-icon>email</mat-icon>
          {{ "Manage email sending" | translate }}
        </button>
      </span>
      -->
    </mat-menu>

    <div class="ws-popup-content">
      <div class="ws-popup-body">
        <div
          class="content-experience-top"
          formGroupName="reservation"
          style="display: flex"
        >
          <div
            class="top-left"
            style="width: 60%; display: flex; justify-content: space-between"
          >
            <div class="reservation-experience-mandatory" style="width: 100%">
              <div class="content-row">
                <!-- RESERVATION-->
                <div class="field-wrapper reservation-experience column">
                  <!-- EXPERIENCE -->
                  <div *ngIf="!canEditCoreInfo" style="width: 100%">
                    <label for="title" class="mt-0">{{
                      "Experience" | translate
                    }}</label>
                    <input
                      [value]="experience ? getExperienceName(experience) : ''"
                      id="title"
                      class="big-select"
                      matInput
                      readonly
                      type="text"
                      style="width: 100% !important"
                    />
                  </div>

                  <div *ngIf="canEditCoreInfo" style="width: 100%">
                    <label for="title">{{ "Experience" | translate }}*</label>
                    <input
                      type="text"
                      matInput
                      class="big-select"
                      [matAutocomplete]="auto"
                      [disabled]="isExperienceFieldDisabled"
                      (input)="filterExperiences($event)"
                      [value]="getExperienceName(experience)"
                      (input)="experience = undefined"
                      style="width: 100% !important"
                    />
                    <mat-autocomplete
                      #auto="matAutocomplete"
                      [displayWith]="getExperienceName"
                      (optionSelected)="experience = $event.option.value"
                    >
                      <mat-option
                        *ngFor="let experience of filteredExperiences"
                        [value]="experience"
                      >
                        {{ getExperienceName(experience) }}
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                </div>
              </div>
              <div
                class="content-row reservation-information"
                style="display: flex; justify-content: space-between"
              >
                <!-- DATES and time-->
                <ng-container *ngIf="!useEventDatePicker">
                  <div
                    id="reservation-date"
                    (click)="
                      experience &&
                        canEditField('date') &&
                        (canEdit || confirmed || waiting) &&
                        datepicker.open()
                    "
                    class="field-wrapper column"
                    style="
                      flex: 0 0 25%;
                      max-width: 25%;
                      box-sizing: border-box;
                      padding-right: 20px;
                    "
                  >
                    <label>{{ "Date" | translate }}*</label>
                    <input
                      style="width: 100% !important; box-sizing: border-box"
                      [matDatepicker]="datepicker"
                      (dateChange)="reservationDateChanged($event)"
                      formControlName="date"
                      class="smallInput"
                      [class.reservation-input-invalid]="reservationFieldInvalid('date')"
                      [readonly]="reservation && !canEditField('date')"
                      id="date1"
                      matInput
                      type="text"
                      autocomplete="off"
                    />
                    <mat-datepicker #datepicker></mat-datepicker>
                    <span
                      *ngIf="reservationFieldInvalid('date')"
                      class="field-error-text"
                      >{{ "Select the booking date" | translate }}</span
                    >
                  </div>

                  <div
                    id="reservation-time"
                    style="
                      flex: 0 0 25%;
                      max-width: 25%;
                      box-sizing: border-box;
                      padding-right: 20px;
                    "
                    class="field-wrapper column"
                  >
                    <label for="time1">{{ "Time" | translate }}*</label>
                    <input
                      style="width: 100% !important; box-sizing: border-box"
                      [matAutocomplete]="timeAutoComplete"
                      [readonly]="reservation && !canEditField('time')"
                      formControlName="time"
                      class="smallInput"
                      [class.reservation-input-invalid]="reservationFieldInvalid('time')"
                      id="time1"
                      matInput
                      type="time"
                    />
                    <mat-autocomplete #timeAutoComplete="matAutocomplete">
                      <mat-option
                        *ngFor="let time of availableTimes"
                        [value]="time"
                        class="smallInput"
                      >
                        {{ time }}
                      </mat-option>
                    </mat-autocomplete>
                    <span
                      *ngIf="reservationFieldInvalid('time')"
                      class="field-error-text"
                      >{{ "Select the start time" | translate }}</span
                    >
                  </div>
                </ng-container>

                <ng-container *ngIf="useEventDatePicker">
                  <div id="reservation-event-date" class="field-wrapper column">
                    <label for="date2">{{ "Date" | translate }}*</label>
                    <mat-select
                      formControlName="event_date"
                      [disabled]="!canEditField('date')"
                      id="event_date"
                      [class.reservation-input-invalid]="reservationFieldInvalid('event_date')"
                    >
                      <mat-option
                        *ngFor="let eventDate of eventDates"
                        [value]="eventDate"
                      >
                        {{ displayDate(eventDate) }}
                      </mat-option>
                    </mat-select>
                    <span
                      *ngIf="reservationFieldInvalid('event_date')"
                      class="field-error-text"
                      >{{ "Select the booking date" | translate }}</span
                    >
                  </div>
                </ng-container>

                <!-- LANGUAGES -->
                <div
                  id="reservation-lang"
                  style="
                    flex: 0 0 25%;
                    max-width: 25%;
                    box-sizing: border-box;
                    padding-right: 20px;
                  "
                  class="field-wrapper column"
                >
                  <label for="lang">{{ "Language" | translate }}*</label>
                  <div *ngIf="!canEditCoreInfo || (reservationToClone && !isNewReservationFromCalendar)" style="display: flex; align-items: center; gap: 8px;">
                    <ws-flag
                      *ngIf="form.get('reservation')?.get('lang')?.value"
                      [countryCode]="
                        getCountryCodeForLanguage(
                          form.get('reservation')?.get('lang')?.value
                        )
                      "
                      [showBorder]="true"
                      size="small"
                    >
                    </ws-flag>
                    <input
                      style="width: 100% !important; box-sizing: border-box"
                      [value]="
                        form.get('reservation')?.get('lang')?.value
                          ? ('lang_' +
                              form.get('reservation')?.get('lang')?.value
                            | translate)
                          : ''
                      "
                      id="lang"
                      matInput
                      class="mediumInput"
                      readonly
                      type="text"
                    />
                  </div>
                  <mat-select
                    *ngIf="canEditCoreInfo && (!reservationToClone || isNewReservationFromCalendar)"
                    class="mediumInput"
                    formControlName="lang"
                    [class.reservation-input-invalid]="reservationFieldInvalid('lang')"
                  >
                    <mat-option
                      *ngFor="
                        let lang of experienceLanguages;
                        trackBy: trackByLanguage
                      "
                      [value]="lang"
                    >
                      <div style="display: flex; align-items: center; gap: 8px">
                        <ws-flag
                          [countryCode]="getCountryCodeForLanguage(lang)"
                          [showBorder]="true"
                          size="small"
                        >
                        </ws-flag>
                        {{ "lang_" + lang | translate }}
                      </div>
                    </mat-option>
                  </mat-select>
                  <span
                    *ngIf="reservationFieldInvalid('lang')"
                    class="field-error-text"
                    >{{ "Select the language of the booking" | translate }}</span
                  >
                </div>


                <div
                  style="flex: 0 0 25%; max-width: 25%; box-sizing: border-box"
                  class="field-wrapper column"
                >
                  <label for="interval">
                    {{ ("Duration" | translate) + "*" }}</label
                  >
                  <input
                    style="width: 100% !important; box-sizing: border-box"
                    [value]="getDuration()"
                    class="smallInput"
                    id="interval"
                    matInput
                    readonly
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="top-right" style="width: 40%">
            <div style="width: 100%; display: flex">
              <div
                class="left-column"
                style="
                  width: 50%;
                  min-width: 50%;
                  max-width: 50%;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                "
              >
                <!-- STATUS -->
                <div
                  class="field-wrapper"
                  *ngIf="reservation && reservation.state"
                >
                  <label class="labelForSection status-field-label" for="status"
                    >{{ "Status" | translate }}:</label
                  >
                  <div class="column" style="gap: 10px">
                    <div class="imageForStatusAndText">
                      <img
                        *ngIf="reservation?.state === 'completed'"
                        alt="completed"
                        class="statusImagesIconReservation"
                        src="assets/icons/status/completed.png"
                      />
                      <img
                        *ngIf="reservation?.state === 'confirmed'"
                        alt="confirmed"
                        class="statusImagesIconReservation"
                        src="assets/icons/status/confirmed.png"
                      />
                      <img
                        *ngIf="reservation?.state === 'draft'"
                        alt="draft"
                        class="statusImagesIconReservation"
                        src="assets/icons/status/draft.png"
                      />
                      <img
                        *ngIf="reservation?.state === 'waiting'"
                        alt="waiting"
                        class="statusImagesIconReservation"
                        src="assets/icons/status/waiting.png"
                      />
                      <img
                        *ngIf="reservation?.state === 'revoked'"
                        alt="revoked"
                        class="statusImagesIconReservation"
                        src="assets/icons/status/revoked.png"
                      />
                      <img
                        *ngIf="reservation?.state === 'rejected'"
                        alt="rejected"
                        class="statusImagesIconReservation"
                        src="assets/icons/status/rejected.png"
                      />
                      <img
                        *ngIf="reservation?.state === 'canceled'"
                        alt="rejected"
                        class="statusImagesIconReservation"
                        src="assets/icons/status/rejected.png"
                      />
                      <label class="singleDetailsStatus color-base-6">{{
                        capitalize(reservation?.state!) | translate
                      }}</label>
                    </div>
                    <ws-button
                      (click)="
                        this.reservation.state === 'waiting'
                          ? confirmReservationClicked()
                          : saveClicked()
                      "
                      *ngIf="
                        reservation &&
                        (this.reservation.state === 'waiting' ||
                          this.reservation.state === 'draft')
                      "
                      [disabled]="
                        isConfirmingOrRejecting ||
                        !canEditField('change_status')
                      "
                      [callToActionType]="'success'"
                    >
                      <mat-icon>check</mat-icon>
                      {{ "Confirm!" | translate }}
                    </ws-button>
                    <ws-button
                      (click)="rejectReservationClicked()"
                      *ngIf="
                        reservation && this.reservation.state === 'waiting'
                      "
                      [disabled]="
                        isConfirmingOrRejecting ||
                        !canEditField('change_status')
                      "
                      [callToActionType]="'danger'"
                    >
                      <mat-icon>close</mat-icon>
                      {{ "Reject!" | translate }}
                    </ws-button>
                    <ws-button
                      (click)="revokeReservationClicked()"
                      [disabled]="
                        isConfirmingOrRejecting ||
                        !canEditField('change_status')
                      "
                      *ngIf="
                        reservation &&
                        (this.reservation.state === 'confirmed' ||
                          this.reservation.state === 'completed')
                      "
                      [callToActionType]="'danger'"
                    >
                      {{ "Revoke!" | translate }}
                    </ws-button>
                    <ws-chip
                      *ngIf="reservation && showRefundStatusBadge"
                      class="payment-refund-status-chip"
                      [label]="refundStatusBadgeLabel"
                      [type]="'info'"
                    ></ws-chip>
                    <ws-button
                      (click)="refundReservationClicked()"
                      [disabled]="
                        isConfirmingOrRejecting ||
                        !canEditField('change_status')
                      "
                      *ngIf="reservation && canRefundReservation"
                      [callToActionType]="'danger'"
                    >
                      <mat-icon>payment</mat-icon>
                      {{ "Refund!" | translate }}
                    </ws-button>
                    <ws-button
                      (click)="cancelReservationClicked()"
                      *ngIf="reservation && this.reservation.state === 'draft'"
                      [disabled]="
                        isConfirmingOrRejecting ||
                        !canEditField('change_status')
                      "
                      [callToActionType]="'danger'"
                    >
                      <mat-icon>delete</mat-icon>
                      {{ "Cancel!" | translate }}
                    </ws-button>
                  </div>
                </div>
              </div>
              <div
                class="right-column"
                style="
                  width: 50%;
                  min-width: 50%;
                  max-width: 50%;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                "
              >
                <div
                  *ngIf="
                    reservation?.state !== 'waiting' &&
                    (form.get('reservation')!.get('paid')!.value ||
                      !hasActiveUnpaidPaymentLink())
                  "
                  class="field-wrapper"
                  [class.field-invalid]="missingPaidHighlight"
                  style="flex-direction: row"
                >
                  <mat-icon>payments</mat-icon>
                  <mat-checkbox
                    (change)="changePaid($event)"
                    class="toolbarCheckDisabled inverted"
                    formControlName="paid"
                    >{{ "Paid Check" | translate }}
                  </mat-checkbox>
                </div>
                <div
                  *ngIf="
                    reservation?.state !== 'waiting' &&
                    hasActiveUnpaidPaymentLink()
                  "
                  class="field-wrapper"
                  style="flex-direction: row; font-size: smaller"
                >
                  {{ "Paid Check" | translate }}
                  &nbsp;
                  <mat-icon
                    [wsTooltip]="
                      'Waiting for the payment to be completed' | translate
                    "
                    >access_time</mat-icon
                  >
                </div>
                <div
                  *ngIf="reservation?.state === 'waiting'"
                  class="field-wrapper"
                  style="flex-direction: row"
                >
                  <mat-icon>payments</mat-icon>
                  <mat-checkbox
                    [checked]="
                      form.get('reservation')!.get('paid')?.value! || false
                    "
                    class="toolbarCheckDisabled inverted"
                    style="flex-direction: row"
                    disabled
                    >{{ "Authorized" | translate }}
                  </mat-checkbox>
                </div>
                <div class="field-wrapper" style="flex-direction: row">
                  <mat-icon>receipt_long</mat-icon>
                  <mat-checkbox
                    class="toolbarCheckDisabled inverted"
                    formControlName="isSales"
                    >{{ "Invoice / Receipt" | translate }}
                  </mat-checkbox>
                  <mat-icon *ngIf="invoiceKeys.length > 0 && !form.get('reservation')!.get('isSales')!.value"
                    [wsTooltip]="'Client has requested an invoice' | translate" class="invoice-requested-icon"
                    style="position: absolute; right: 20px;">
                    error
                  </mat-icon>
                </div>
                <div class="field-wrapper" style="flex-direction: row">
                  <mat-icon>location_on</mat-icon>
                  <mat-checkbox
                    class="toolbarCheckDisabled inverted"
                    formControlName="checkedIn"
                    >{{ "Check In" | translate }}
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="content-experience-bottom"
          formGroupName="reservation"
          style="display: flex; max-height: 800px"
        >
          <div
            class="bottom-left"
            style="
              width: 60%;
              max-height: 600px;
              display: flex;
              justify-content: space-between;
            "
          >
            <div
              class="left-column scrollbar-overflow-y"
              style="max-height: 100%; overflow: hidden"
            >
              <div
                id="participants-section"
                [class.participants-invalid]="reservationFieldInvalid('experience_price_labels')"
              >
              <div>
                <div class="field-wrapper">
                  <label for="labels" class="labelForSection mt-0">
                    {{ ("Partecipants" | translate) + "*" }}
                  </label>
                  <span
                    *ngIf="reservationFieldInvalid('experience_price_labels')"
                    class="field-error-text"
                    >{{ "Add at least one participant to save the booking" | translate }}</span
                  >
                </div>
              </div>

              <div
                *ngFor="let priceLabel of formArrayPriceLabels; let i = index"
                [formGroup]="priceLabel"
                class="field-wrapper"
              >
                <label for="priceLabel">
                  {{
                    getPriceRowCaption(priceLabel, i, "LABEL")
                      | truncate : [16, "..."]
                  }}
                  <span class="labelPrice"
                    >({{
                      getPriceRowCentsForDisplay(priceLabel)
                        | currency : "EUR" : currencySymbol : "1.2-2"
                    }})</span
                  >
                </label>
                <input
                  [readonly]="!canEditPartecipants() || hasActiveUnpaidPaymentLink()"
                  formControlName="quantity"
                  id="priceLabel"
                  matInput
                  min="0"
                  type="number"
                  [class.reservation-input-invalid]="reservationFieldInvalid('experience_price_labels')"
                />
              </div>
              </div>
              <div
                class="field-wrapper"
                *ngIf="formArrayPriceExtras && formArrayPriceExtras.length > 0"
              >
                <label for="extras" class="labelForSection">
                  <!-- <img alt="conversion" src="assets/icons/icon-price-e.png" /> -->
                  {{ "Extra" | translate }}:</label
                >
              </div>

              <div
                *ngFor="let priceExtra of formArrayPriceExtras; let i = index"
                [formGroup]="priceExtra"
                class="field-wrapper"
              >
                <label for="priceExtra">
                  {{
                    getPriceRowCaption(priceExtra, i, "EXTRA")
                      | truncate : [16, "..."]
                  }}
                  <span class="labelPrice"
                    >({{
                      getPriceRowCentsForDisplay(priceExtra)
                        | currency : "EUR" : currencySymbol : "1.2-2"
                    }})</span
                  >
                </label>
                <input
                  [readonly]="!canEditPartecipants() || hasActiveUnpaidPaymentLink()"
                  formControlName="quantity"
                  id="priceExtra"
                  matInput
                  min="0"
                  type="number"
                />
              </div>
            </div>

            <div
              class="middle-column scrollbar-overflow-y"
              style="max-height: 100%; overflow: hidden"
            >
              <div
                class="field-wrapper"
                [class.field-invalid]="missingPaymentModeHighlight"
              >
                <label class="mt-0" for="payment_method">
                  {{ "Terms of payment" | translate }}</label
                >
                <mat-select
                  formControlName="payment_method"
                  id="payment_method"
                  placeholder="-"
                  (selectionChange)="selectPayment2MethodIfThereIsOnlyOne()"
                >
                  <mat-option [value]="null"></mat-option>
                  <mat-option
                    *ngFor="
                      let pm of paymentMethods;
                      trackBy: trackByPaymentMethod
                    "
                    [value]="pm"
                    >{{ getTranslatedName(pm) }}
                  </mat-option>
                </mat-select>
                <span
                  *ngIf="missingPaymentModeHighlight"
                  class="field-error-text"
                  >{{ "receipt.missingPaymentMode" | translate }}</span
                >
              </div>

              <div
                *ngIf="
                  form.get('reservation')!.get('payment_method')!.value ||
                  missingPaymentMethodHighlight
                "
                class="field-wrapper"
                [class.field-invalid]="missingPaymentMethodHighlight"
              >
                <label for="payment2_method" class="payment-method-label">
                  <span class="payment-method-label-text">{{ "Method of payment" | translate }}</span>
                  <button
                    *ngIf="isDwspayPayment && hasDwspayPaymentDetailLink"
                    type="button"
                    mat-icon-button
                    class="payment-detail-icon-btn"
                    (click)="openDwspayPaymentDetailDialog()"
                    [wsTooltip]="'View payment details' | translate"
                    [attr.aria-label]="'View payment details' | translate"
                  >
                    <mat-icon>payment</mat-icon>
                  </button>
                  <mat-icon
                    style="cursor: pointer"
                    (click)="openPaymentPage()"
                    *ngIf="!isDwspayPayment && (paidOnline || (!!paymentLinkData && isPaid()))"
                    class="paymentIcon"
                    [wsTooltip]="'Open payment page' | translate"
                    >launch
                  </mat-icon>
                  <mat-icon
                    style="cursor: pointer"
                    (click)="openWSPaymentPage()"
                    *ngIf="mustShowWSPaymentIcon()"
                    class="paymentIcon ws-payment-icon"
                    [wsTooltip]="'Open payment form (WSPayments)' | translate"
                    >credit_card
                  </mat-icon>
                </label>
                <mat-select
                  formControlName="payment2_method"
                  id="payment2_method"
                  (selectionChange)="clearCommercialDocumentPaymentHighlights()"
                >
                  <mat-option
                    *ngFor="
                      let pm of form.get('reservation')!.get('payment_method')!
                        .value?.children || []
                    "
                    [value]="pm"
                    [disabled]="hasActiveUnpaidPaymentLink()"
                  >
                    {{ getTranslatedName(pm) }}
                  </mat-option>
                </mat-select>
                <span
                  *ngIf="missingPaymentMethodHighlight"
                  class="field-error-text"
                  >{{ "receipt.missingPaymentMethod" | translate }}</span
                >
              </div>

              <div class="field-wrapper field-total">
                <label for="total_calculated">{{
                  "Subtotal" | translate
                }}</label>
                <input
                  [suffix]="' ' + currencySymbol"
                  formControlName="total_calculated"
                  id="total_calculated"
                  mask="separator.2"
                  readonly
                  matInput
                  type="text"
                />
              </div>

              <div class="field-wrapper">
                <label for="discount">
                  <span
                    class="switch-by-meri"
                    [title]="getDiscountCodeTooltip()"
                  >
                    <input
                      [checked]="showCouponToggle"
                      [ngClass]="{ 'gift-associated': isGift }"
                      type="checkbox"
                      (change)="toggleCouponGiftSwitch($any($event.target).checked)"
                    />
                    <label for="switcher"></label>
                  </span>
                </label>
                <ng-container *ngIf="showCouponToggle">
                  <input
                    *ngIf="isCouponDiscountReadonly && couponPercent == null"
                    [suffix]="
                      ' ' + currencySymbol + (coupon ? ' - ' + coupon : '')
                    "
                    formControlName="discount"
                    id="discount"
                    mask="separator.2"
                    matInput
                    readonly="true"
                    type="text"
                  />
                  <input
                    *ngIf="isCouponDiscountReadonly && couponPercent != null"
                    [value]="couponPercent + ' %' + (coupon ? ' - ' + coupon : '')"
                    id="discount-percent"
                    matInput
                    readonly="true"
                    type="text"
                  />
                  <mat-select
                    *ngIf="!isCouponDiscountReadonly"
                    formControlName="coupon_code"
                  >
                    <mat-option [value]=""></mat-option>
                    <mat-option *ngIf="loadingCoupons">
                      <span class="loading-coupons" disabled>
                        <mat-spinner diameter="16"></mat-spinner>
                        Loading coupons...
                      </span>
                    </mat-option>
                    <mat-option
                      *ngFor="let coupon of availableCoupons"
                      [value]="coupon.code"
                    >
                      {{ coupon.code }} -
                      {{
                        coupon.discount_type == "percent"
                          ? coupon.discount_percent + "%"
                          : (coupon.discount_cents / 100
                            | currency : "EUR" : currencySymbol : "1.2-2")
                      }}
                    </mat-option>
                  </mat-select>
                </ng-container>
                <input
                  *ngIf="!showCouponToggle"
                  [suffix]="' ' + currencySymbol"
                  formControlName="giftAmount"
                  mask="separator.2"
                  matInput
                  readonly="true"
                  type="text"
                />
              </div>

              <div class="field-wrapper">
                <label for="additional_discount">{{
                  "Additional Discount" | translate
                }}</label>
                <input
                  [suffix]="' ' + currencySymbol"
                  formControlName="additional_discount"
                  id="additional_discount"
                  mask="separator.2"
                  matInput
                  type="text"
                  (keyup)="additionalDiscountChanged()"
                  [readonly]="
                    hasActiveUnpaidPaymentLink() || !canEditField('additional_discount')
                  "
                />
              </div>

              <div class="field-wrapper field-total">
                <label class="totalTypeLabel" for="total">
                  {{ "Total" | translate }}
                  <mat-icon
                    *ngIf="isTotalWarning()"
                    class="warning"
                    [wsTooltip]="
                      'The total is not equal to the value of the Subtotal minus the Discounts.'
                        | translate
                    "
                  >
                    warning
                  </mat-icon>
                </label>
                <input
                  [allowNegativeNumbers]="true"
                  [suffix]="' ' + currencySymbol"
                  formControlName="total"
                  id="total"
                  mask="separator.2"
                  matInput
                  type="text"
                  [readonly]="hasActiveUnpaidPaymentLink() || !canEditField('total')"
                />
              </div>
              <div class="field-wrapper">
                <label class="totalTypeLabel" for="paidAmout">
                  {{ "Paid" | translate }}
                </label>
                <input
                  [allowNegativeNumbers]="false"
                  [suffix]="' ' + currencySymbol"
                  formControlName="paidAmout"
                  [class.isPaidPositive]="
                    form.get('reservation')?.get('paidAmout')?.value > 0
                  "
                  id="paidAmout"
                  mask="separator.2"
                  matInput
                  type="text"
                  (keyup)="updateTotal('paidAmout', getInputValue($event))"
                  [readonly]="hasActiveUnpaidPaymentLink() || !canEditField('paidAmout')"
                />
              </div>
              <div class="field-wrapper">
                <label class="totalTypeLabel" for="due">
                  {{
                    form.get("reservation")?.get("due")?.value >= 0
                      ? ("Due" | translate)
                      : ("Refound" | translate)
                  }}
                </label>
                <input
                  [allowNegativeNumbers]="false"
                  [suffix]="' ' + currencySymbol"
                  [class.isDuePositive]="
                    form.get('reservation')?.get('due')?.value > 0
                  "
                  formControlName="due"
                  id="due"
                  mask="separator.2"
                  matInput
                  type="text"
                  (keyup)="updateTotal('due', getInputValue($event))"
                  [readonly]="hasActiveUnpaidPaymentLink() || !canEditField('due')"
                />
              </div>
              <div
                class="field-wrapper"
                *ngIf="form.get('reservation')?.get('refundedAmount')?.value > 0"
              >
                <label class="totalTypeLabel" for="refundedAmount">
                  {{ "Refunded amount" | translate }}
                  <web-info-icon-hoverable
                    *ngIf="refundDate"
                    position="above"
                    [description]="
                      ('Refunded on' | translate) +
                      ' ' +
                      formatRefundDate(refundDate)
                    "
                  ></web-info-icon-hoverable>
                </label>
                <input
                  [allowNegativeNumbers]="false"
                  [suffix]="' ' + currencySymbol"
                  formControlName="refundedAmount"
                  [class.isRefundedPositive]="
                    form.get('reservation')?.get('refundedAmount')?.value > 0
                  "
                  id="refundedAmount"
                  mask="separator.2"
                  matInput
                  type="text"
                  readonly
                />
              </div>
            </div>

            <div
              class="right-column scrollbar-overflow-y"
              style="max-height: 100%; overflow: hidden"
            >
              <div class="reservation-information">
                <div class="reservation-additional-information">
                  <div class="field-wrapper">
                    <label class="mt-0" for="origin">
                      {{ "Origin" | translate }}</label
                    >

                    <ng-container
                      *ngIf="reservation && reservation.type != 'manual'"
                    >
                      <input
                        id="origin"
                        matInput
                        readonly
                        type="text"
                        value="{{ getOrigin(reservation.origin) }}"
                      />
                    </ng-container>

                    <ng-container
                      *ngIf="!reservation || reservation.type == 'manual'"
                    >
                      <input
                        *ngIf="!canEdit"
                        formControlName="manual_origin"
                        matInput
                        readonly
                        type="text"
                      />
                      <mat-select
                        *ngIf="canEdit"
                        [compareWith]="compareManualOrigin"
                        formControlName="manual_origin"
                      >
                        <mat-option value="0"></mat-option>
                        <mat-option
                          *ngFor="
                            let origin of manualOrigins;
                            trackBy: trackByManualOrigin
                          "
                          [value]="origin"
                        >
                          {{ origin | translatable : "name" : "pascal" }}
                        </mat-option>
                      </mat-select>
                    </ng-container>
                  </div>

                  <div *ngIf="false" class="field-wrapper">
                    <label for="visit_reason">
                      {{ "Visit reason" | translate }}</label
                    >
                    <input
                      *ngIf="!canEdit"
                      formControlName="visit_reason_name"
                      id="visit_reason"
                      matInput
                      readonly
                      type="text"
                    />
                    <mat-select *ngIf="canEdit" formControlName="visit_reason">
                      <mat-option value=""></mat-option>
                      <mat-option
                        *ngFor="let visitReason of availableVisitReasons"
                        [value]="visitReason.id"
                      >
                        {{ getTranslatedName(visitReason) }}
                      </mat-option>
                    </mat-select>
                  </div>

                  <div class="field-wrapper">
                    <label for="room">{{ "Room" | translate }}</label>
                    <mat-select
                      [compareWith]="compareRoom"
                      formControlName="room"
                      id="room"
                    >
                      <mat-option value="0"></mat-option>
                      <mat-option
                        *ngFor="let room of rooms; trackBy: trackByRoom"
                        [value]="room"
                      >
                        {{ room.name }}
                      </mat-option>
                    </mat-select>
                  </div>

                  <div class="field-wrapper">
                    <label for="employee"> {{ "Employee" | translate }}</label>
                    <mat-select
                      [compareWith]="compareEmployee"
                      formControlName="employee"
                      id="employee"
                    >
                      <mat-option value="0"></mat-option>
                      <mat-option
                        *ngFor="let employee of team; trackBy: trackByEmployee"
                        [value]="employee"
                      >
                        {{ employee.firstName }} {{ employee.lastName }}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div class="field-wrapper notes-field">
                    <label class="notes" for="message">
                      {{ "Message" | translate }}</label
                    >
                    <textarea
                      class="message"
                      formControlName="message"
                      id="message"
                      readonly
                      style="pointer-events: all"
                    ></textarea>
                    <!-- formControlName="message"  -->
                  </div>
                  <div class="field-wrapper notes-field">
                    <label class="notes" for="notes">
                      {{ "Notes" | translate }}</label
                    >
                    <textarea
                      class="textarea-wrapper"
                      formControlName="notes"
                      [readOnly]="!canEditField('notes')"
                      id="notes"
                      maxlength="500"
                    ></textarea>
                  </div>
                  <web-reservation-additional-questions-action
                    *ngIf="reservation?.id"
                    [reservationId]="reservation.id"
                    display="quick"
                  ></web-reservation-additional-questions-action>
                </div>

                <br />
              </div>
            </div>
          </div>

          <div
            class="bottom-right scrollbar-overflow-y client-contacts-column"
            style="width: 40%; max-height: 600px; overflow: hidden"
          >
            <div
              *ngIf="loadingContactAdd"
              class="client-contact-add-loading-overlay"
              role="status"
              aria-live="polite"
            >
              <div class="client-contact-add-loading-inner">
                <mat-spinner diameter="40"></mat-spinner>
                <span class="client-contact-add-loading-text">{{
                  "Loading contact..." | translate
                }}</span>
              </div>
            </div>
            <div class="title display-flex justify-space-between mb5">
              <div>
                <span class="labelForSection" *ngIf="!isTourOperator"
                  >{{ "Client" | translate }}*</span
                >
                <span class="labelForSection" *ngIf="isTourOperator"
                  >{{ "Tour Operator" | translate }}*</span
                >
              </div>
              <div
                class="align-items-center display-flex"
                *ngIf="!isTourOperator"
              >
                <mat-slide-toggle
                  formControlName="notify_contact"
                ></mat-slide-toggle>
                <span class="email-label">
                  {{ "Transactional emails" | translate }}
                </span>
              </div>
            </div>
            <div class="client-wrapper dws-elevation-z1">
              <div class="client-information">
                <div
                  *ngIf="
                    hasClientAssocieted(masterContactControl?.get('id')?.value)
                  "
                  class="client-data"
                >
                  <div class="rowLT">
                    <div
                      [ngClass]="{
                        pointer:
                          !!masterContactControl?.get('crmContactId')?.value
                      }"
                      (click)="
                        openCrmContactPage(
                          masterContactControl?.get('crmContactId')?.value
                        )
                      "
                    >
                      <strong
                        class="full-name"
                        [ngClass]="{
                          underline:
                            !!masterContactControl?.get('crmContactId')?.value
                        }"
                        >{{ masterContactControl!.get("firstName")?.value
                        }}<ng-container *ngIf="!isTourOperator">
                          {{ " " }}{{ masterContactControl!.get("lastName")?.value }}</ng-container></strong
                      >
                    </div>
                    <div
                      *ngIf="
                        hasClientAssocieted(
                          masterContactControl?.get('id')?.value
                        )
                      "
                      class="actions"
                    >
                      <button
                        class="addModifySearchButton"
                        mat-icon-button
                        (click)="
                          $event.stopPropagation();
                          editClientClicked(
                            masterContactControl?.get('id')?.value
                          )
                        "
                        [disabled]="
                          hasActiveUnpaidPaymentLink() || !canEditField('contact')
                        "
                      >
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button
                        class="addModifySearchButton"
                        mat-icon-button
                        (click)="
                          $event.stopPropagation();
                          removeClientClicked(
                            masterContactControl?.get('id')?.value
                          )
                        "
                        [disabled]="
                          hasActiveUnpaidPaymentLink() || !canEditField('contact')
                        "
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>

                  <div class="rowLT mt-10">
                    <strong class="email">{{
                      masterContactControl!.get("email")?.value
                    }}</strong>
                    <div>
                      <span class="country">
                          {{
                            getOrderCountryByIso(
                              getContactCountryIso(
                                masterContactControl?.get("id")?.value
                              )
                            ) | translatable : "name" : "pascal"
                          }}
                        <ws-flag [countryCode]="getContactCountryIso(
                        masterContactControl?.get('id')?.value
                      )" size="medium" [showBorder]="true"></ws-flag></span>
                    </div>
                  </div>
                  <div class="rowLT">
                    <span class="phone">{{
                      masterContactControl!.get("phoneNumber")?.value
                    }}</span>
                  </div>

                  <ng-container *let="{ open: false } as invoiceSectionCtrl">
                    <div *ngIf="invoiceKeys.length > 0" class="rowLT">
                      <strong
                        (click)="
                          invoiceSectionCtrl.open = !invoiceSectionCtrl.open
                        "
                        class="moreinfo"
                      >
                        {{ "Billing Data" | translate }}
                        <i
                          [class.arrow-up]="invoiceSectionCtrl.open"
                          class="icon-arrow-down"
                        ></i>
                      </strong>
                    </div>

                    <div
                      *ngIf="invoiceSectionCtrl.open"
                      class="additionalInfo invoice-data-panel"
                    >
                      <div
                        *ngFor="let invoiceProperty of invoiceKeys"
                        class="row"
                      >
                        <strong>{{
                          "invoiceFields." + invoiceProperty | translate
                        }}</strong>
                        <span>{{ invoiceFieldDisplayValue(invoiceProperty) }}</span>
                      </div>
                      <div
                        *ngIf="isInvoiceIntestatarioNameFallback"
                        class="invoice-legacy-banner"
                      >
                        {{
                          "Billing intestatario names fallback notice" | translate
                        }}
                      </div>
                    </div>
                  </ng-container>

                  <div
                    *ngIf="masterContactControl?.get('crmContactId')?.value"
                    class="rowLT"
                  >
                    <strong
                      (click)="
                        $event.stopPropagation();
                        contactDetailOpen[
                          masterContactControl?.get('id')?.value
                        ] =
                          !contactDetailOpen[
                            masterContactControl?.get('id')?.value
                          ]
                      "
                      class="moreinfo"
                    >
                      {{ "CRM Customer info" | translate }}
                      <i
                        [class.arrow-up]="
                          contactDetailOpen[
                            masterContactControl?.get('id')?.value
                          ]
                        "
                        class="icon-arrow-down"
                      ></i>
                    </strong>
                    <span
                      *ngIf="
                        objectKeys(
                          contactsNotMatchingAlerts[
                            masterContactControl?.get('id')?.value
                          ]
                        )?.length
                      "
                    >
                      {{ "Data not matching" | translate }}
                      <web-info-icon-hoverable
                        #iconHoverables
                        [description]="
                          (
                            'reservation-warning-contact-differences'
                            | translate
                          ).replace(
                            '{}',
                            objectKeys(
                              contactsNotMatchingAlerts[
                                masterContactControl?.get('id')?.value
                              ]
                            ).join(', ')
                          )
                        "
                      ></web-info-icon-hoverable>
                    </span>
                  </div>

                  <div
                    *ngIf="
                      masterContactControl?.get('crmContactId')?.value &&
                      contactDetailOpen[masterContactControl?.get('id')?.value]
                    "
                    class="additionalInfo crm-customer-info-panel"
                  >
                    <div
                      class="row"
                      *ngFor="
                        let differentInfoName of objectKeys(
                          contactsNotMatchingAlerts[
                            masterContactControl?.get('id')?.value
                          ]
                        )
                      "
                    >
                      <strong class="error-text">{{
                        differentInfoName
                      }}</strong>
                      <span>{{
                        contactsNotMatchingAlerts[
                          masterContactControl?.get("id")?.value
                        ][differentInfoName] || "-"
                      }}</span>
                    </div>

                    <div class="row">
                      <strong>{{ "Client value" | translate }}</strong>
                      <span>{{
                        (contactsData[masterContactControl?.get("id")?.value]
                          .contactStatistics?.total || 0) / 100
                          | currency : "EUR" : "symbol"
                      }}</span>
                    </div>

                    <div class="row">
                      <strong>{{ "Last purchases" | translate }}</strong>
                      <span>{{
                        (contactsData[masterContactControl?.get("id")?.value]
                          .contactStatistics?.date | date) || "-"
                      }}</span>
                    </div>

                    <div class="row">
                      <strong>{{ "Total purchases" | translate }}</strong>
                      <span>{{
                        contactsData[masterContactControl?.get("id")?.value]
                          .contactStatistics?.count
                      }}</span>
                    </div>

                    <div class="row">
                      <strong>{{
                        "Marketing subscription" | translate
                      }}</strong>
                      <span
                        *ngIf="
                          (contactsData[masterContactControl?.get('id')?.value]
                            .contactPrivacy?.acceptedPrivacyTerms &&
                            (contactsData[
                              masterContactControl?.get('id')?.value
                            ].contactPrivacy?.acceptedMarketing ||
                              contactsData[
                                masterContactControl?.get('id')?.value
                              ].contactPrivacy?.acceptedProfiling)) ||
                          contactsData[masterContactControl?.get('id')?.value]
                            .contactPrivacy?.manualMarketing
                        "
                      >
                        {{ "Subscribed" | translate }}
                      </span>
                      <span
                        *ngIf="
                          !contactsData[masterContactControl?.get('id')?.value]
                            .contactPrivacy?.acceptedMarketing &&
                          !contactsData[masterContactControl?.get('id')?.value]
                            .contactPrivacy?.acceptedProfiling &&
                          !contactsData[masterContactControl?.get('id')?.value]
                            .contactPrivacy?.manualMarketing
                        "
                      >
                        {{ "Non Subscribered" | translate }}
                      </span>
                      <span
                        *ngIf="
                          contactsData[masterContactControl?.get('id')?.value]
                            .contactPrivacy?.unsubscribed
                        "
                      >
                        {{ "Unsubscribed" | translate }}
                      </span>
                    </div>

                    <div
                      *ngIf="
                        contactsData[masterContactControl?.get('id')?.value]
                          .contactTags?.length
                      "
                      class="row"
                    >
                      <strong>{{ "Tags" | translate }}</strong>
                      <mat-icon
                        (mouseout)="tagsPopoverVisibility = false"
                        (mouseover)="tagsPopoverVisibility = true"
                        style="font-size: large; text-align: right"
                      >
                        remove_red_eye
                      </mat-icon>
                      <div
                        *ngIf="tagsPopoverVisibility"
                        class="popover dws-elevation-z16"
                      >
                        <div
                          *ngFor="
                            let tag of contactsData[
                              masterContactControl?.get('id')?.value
                            ].contactTags
                          "
                          class="tag"
                        >
                          {{ tag.tag.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="
                    !hasClientAssocieted(masterContactControl?.get('id')?.value)
                  "
                  class="client-search-wrapper"
                >
                  <input
                    #trigger="matAutocompleteTrigger"
                    [formControl]="masterSearchControl"
                    (focus)="trigger.openPanel(); onClientSearchFocus(true)"
                    [matAutocompleteDisabled]="false"
                    [matAutocomplete]="clientAutoComplete"
                    autocomplete="chrome-off"
                    type="text"
                    [wsTooltip]="
                      'Type at least {count} characters to search for contacts'
                        | translate: { count: clientSearchMinChars }
                    "
                    [placeholder]="
                      (isTourOperator
                        ? 'Select a tour operator'
                        : 'Select a client'
                      ) | translate
                    "
                  />

                  <mat-autocomplete
                    #clientAutoComplete="matAutocomplete"
                    panelClass="autocomplete-new-client"
                    [displayWith]="displayClientForAutocomplete"
                    (optionSelected)="
                      associateContact(
                        $event.option.value,
                        masterContactControl?.get('id')?.value
                      )
                    "
                  >
                    <mat-option *ngFor="let client of clients" [value]="client">
                      <app-client-contact-autocomplete-option
                        [contact]="client"
                        [displayLocale]="lang"
                      ></app-client-contact-autocomplete-option>
                    </mat-option>

                    <mat-option *ngIf="loadingClients" class="loading" disabled>
                      <mat-spinner diameter="35"></mat-spinner>
                    </mat-option>

                    <mat-option
                      *ngIf="
                        clientSearchShowsMinCharsHint(masterSearchControl) &&
                        !loadingClients
                      "
                      class="no-results-wrapper"
                      disabled
                    >
                      <span>{{
                        "Type at least {count} characters to search for contacts"
                          | translate: { count: clientSearchMinChars }
                      }}</span>
                    </mat-option>

                    <mat-option
                      *ngIf="
                        clients.length === 0 &&
                        !loadingClients &&
                        !clientSearchShowsMinCharsHint(masterSearchControl)
                      "
                      class="no-results-wrapper"
                      disabled
                    >
                      <span>{{ "No user found" | translate }}</span>
                    </mat-option>
                  </mat-autocomplete>

                  <div class="actions">
                    <button
                      (click)="
                        addNewClientClicked(
                          masterContactControl?.get('id')?.value
                        )
                      "
                      class="addModifySearchButton"
                      mat-stroked-button
                      type="button"
                      [disabled]="loadingContactAdd"
                    >
                      {{ "New" | translate }}
                    </button>
                  </div>
                </div>
                <div
                  *ngIf="
                    hasClientAssocieted(masterContactControl?.get('id')?.value)
                  "
                  class="feedback-wrapper"
                >
                  <div class="contact-actions-wrapper">
                    <button
                      (click)="$event.stopPropagation(); sendWhatsApp()"
                      *ngIf="masterContactControl?.get('phoneNumber')?.value"
                      class="whButton"
                      mat-flat-button
                    >
                      <img
                        alt="WhatsApp_logo"
                        class="whatsappLogo"
                        src="/assets/images/WhatsApp_logo.png"
                      />
                      <span class="buttonText">{{
                        "WhatsApp" | translate
                      }}</span>
                    </button>
                    &nbsp;
                    <button
                      (click)="$event.stopPropagation(); sendMailTo()"
                      class="emailToConButton"
                      *ngIf="masterContactControl?.get('email')?.value"
                      mat-flat-button
                    >
                      <span class="material-icons">email</span>
                      <span class="buttonText">{{ "Email" | translate }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngFor="let contactCtrl of secondaryContactsControls"
              [formGroup]="contactCtrl"
              class="client-wrapper dws-elevation-z1"
            >
              <div class="client-information">
                <div
                  *ngIf="!hasClientAssocieted(contactCtrl!.get('id')!.value)"
                  class="client-search-wrapper"
                >
                  <input
                    #trigger="matAutocompleteTrigger"
                    [formControl]="searchControl"
                    (focus)="trigger.openPanel(); onClientSearchFocus(false)"
                    [matAutocompleteDisabled]="false"
                    [matAutocomplete]="clientAutoComplete"
                    autocomplete="chrome-off"
                    type="text"
                    [wsTooltip]="
                      'Type at least {count} characters to search for contacts'
                        | translate: { count: clientSearchMinChars }
                    "
                    [placeholder]="
                      'Search contact (min. {count} characters)'
                        | translate: { count: clientSearchMinChars }
                    "
                  />

                  <mat-autocomplete
                    #clientAutoComplete="matAutocomplete"
                    panelClass="autocomplete-new-client"
                    [displayWith]="displayClientForAutocomplete"
                    (optionSelected)="
                      associateContact(
                        $event.option.value,
                        contactCtrl!.get('id')!.value
                      )
                    "
                  >
                    <mat-option *ngFor="let client of clients" [value]="client">
                      <app-client-contact-autocomplete-option
                        [contact]="client"
                        [displayLocale]="lang"
                      ></app-client-contact-autocomplete-option>
                    </mat-option>

                    <mat-option *ngIf="loadingClients" class="loading" disabled>
                      <mat-spinner diameter="35"></mat-spinner>
                    </mat-option>

                    <mat-option
                      *ngIf="
                        clientSearchShowsMinCharsHint(searchControl) &&
                        !loadingClients
                      "
                      class="no-results-wrapper"
                      disabled
                    >
                      <span>{{
                        "Type at least {count} characters to search for contacts"
                          | translate: { count: clientSearchMinChars }
                      }}</span>
                    </mat-option>

                    <mat-option
                      *ngIf="
                        clients.length === 0 &&
                        !loadingClients &&
                        !clientSearchShowsMinCharsHint(searchControl)
                      "
                      class="no-results-wrapper"
                      disabled
                    >
                      <span>{{ "No user found" | translate }}</span>
                    </mat-option>
                  </mat-autocomplete>

                  <div class="actions">
                    <button
                      (click)="
                        addNewClientClicked(contactCtrl!.get('id')!.value)
                      "
                      class="addModifySearchButton"
                      mat-stroked-button
                      type="button"
                      [disabled]="loadingContactAdd"
                    >
                      {{ "New" | translate }}
                    </button>
                  </div>
                  <button
                    class="addModifySearchButton"
                    (click)="removeClientClicked(contactCtrl?.get('id')?.value)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
                <div
                  *ngIf="hasClientAssocieted(contactCtrl!.get('id')!.value)"
                  class="client-data"
                >
                  <div class="rowLT">
                    <div
                      [ngClass]="{
                        pointer: !!contactCtrl.get('crmContactId').value
                      }"
                      (click)="
                        openCrmContactPage(
                          contactCtrl.get('crmContactId').value
                        )
                      "
                    >
                      <strong
                        class="full-name"
                        [ngClass]="{
                          underline: !!contactCtrl?.get('crmContactId')?.value
                        }"
                        >{{ contactCtrl.get("firstName")?.value }}
                        {{ contactCtrl.get("lastName")?.value }}</strong
                      >
                    </div>
                    <div class="actions">
                      <button
                        (click)="
                          $event.stopPropagation();
                          editClientClicked(contactCtrl!.get('id')!.value)
                        "
                        class="addModifySearchButton"
                        mat-stroked-button
                      >
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button
                        (click)="
                          $event.stopPropagation();
                          removeClientClicked(contactCtrl!.get('id')!.value)
                        "
                        class="addModifySearchButton"
                        mat-stroked-button
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>

                  <div class="rowLT mt-10">
                    <strong class="email">{{
                      contactCtrl.get("email")?.value
                    }}</strong>
                    <div
                      *ngIf="contactCtrl.get('countryIso')?.value as country"
                    >
                      <span>
                        <strong>
                          {{
                            getOrderCountryByIso(country)
                              | translatable : "name" : "pascal"
                          }}
                        </strong>
                        <ws-flag
                          [countryCode]="country"
                          size="medium"
                          [showBorder]="true"
                        ></ws-flag>
                      </span>
                    </div>
                  </div>
                  <div class="rowLT">
                    <span class="phone">{{
                      contactCtrl.get("phoneNumber")?.value
                    }}</span>
                  </div>
                  <div
                    *ngIf="contactCtrl.get('crmContactId').value"
                    class="rowLT"
                  >
                    <strong
                      (click)="
                        $event.stopPropagation();
                        contactDetailOpen[contactCtrl!.get('id')!.value] =
                          !contactDetailOpen[contactCtrl!.get('id')!.value]
                      "
                      class="moreinfo"
                    >
                      {{ "CRM Customer info" | translate }}
                      <i
                        [class.arrow-up]="
                          contactDetailOpen[contactCtrl!.get('id')!.value]
                        "
                        class="icon-arrow-down"
                      ></i>
                    </strong>
                    <span
                      *ngIf="
                        objectKeys(
                          contactsNotMatchingAlerts[
                            contactCtrl!.get('id')!.value
                          ]
                        )?.length
                      "
                      class="hoverableWithPopover"
                    >
                      {{ "Data not matching" | translate }}
                      <web-info-icon-hoverable
                        #iconHoverables
                        [description]="
                          (
                            'reservation-warning-contact-differences'
                            | translate
                          ).replace(
                            '{}',
                            objectKeys(
                              contactsNotMatchingAlerts[
                                contactCtrl!.get('id')!.value
                              ]
                            ).join(', ')
                          )
                        "
                        [overrides]="'left: 50vw !important;'"
                        [showIcon]="false"
                        ><mat-icon class="warning"
                          >warning</mat-icon
                        ></web-info-icon-hoverable
                      >
                    </span>
                  </div>

                  <div
                    *ngIf="contactDetailOpen[contactCtrl!.get('id')!.value]"
                    class="additionalInfo crm-customer-info-panel"
                  >
                    <div
                      class="row"
                      *ngFor="
                        let differentInfoName of objectKeys(
                          contactsNotMatchingAlerts[
                            contactCtrl?.get('id')?.value
                          ]
                        )
                      "
                    >
                      <strong class="error-text">{{
                        differentInfoName
                      }}</strong>
                      <span>{{
                        contactsNotMatchingAlerts[
                          contactCtrl?.get("id")?.value
                        ][differentInfoName] || "-"
                      }}</span>
                    </div>
                    <div class="row">
                      <strong>{{ "Client value" | translate }}</strong>
                      <span>{{
                        (contactsData[contactCtrl!.get("id")!.value]
                          .contactStatistics?.total || 0) / 100
                          | currency : "EUR" : "symbol"
                      }}</span>
                    </div>

                    <div class="row">
                      <strong>{{ "Last purchases" | translate }}</strong>
                      <span>{{
                        (contactsData[contactCtrl!.get("id")!.value]
                          .contactStatistics?.date | date) || "-"
                      }}</span>
                    </div>

                    <div class="row">
                      <strong>{{ "Total purchases" | translate }}</strong>
                      <span>{{
                        contactsData[contactCtrl!.get("id")!.value]
                          .contactStatistics?.count
                      }}</span>
                    </div>

                    <div class="row">
                      <strong>{{
                        "Marketing subscription" | translate
                      }}</strong>
                      <span
                        *ngIf="
                          (contactsData[contactCtrl!.get('id')!.value]
                            .contactPrivacy?.acceptedPrivacyTerms &&
                            (contactsData[contactCtrl!.get('id')!.value]
                              .contactPrivacy?.acceptedMarketing ||
                              contactsData[contactCtrl!.get('id')!.value]
                                .contactPrivacy?.acceptedProfiling)) ||
                          contactsData[contactCtrl!.get('id')!.value]
                            .contactPrivacy?.manualMarketing
                        "
                      >
                        {{ "Subscribed" | translate }}
                      </span>
                      <span
                        *ngIf="
                          !contactsData[contactCtrl!.get('id')!.value]
                            .contactPrivacy?.acceptedMarketing &&
                          !contactsData[contactCtrl!.get('id')!.value]
                            .contactPrivacy?.acceptedProfiling &&
                          !contactsData[contactCtrl!.get('id')!.value]
                            .contactPrivacy?.manualMarketing
                        "
                      >
                        {{ "Non Subscribered" | translate }}
                      </span>
                      <span
                        *ngIf="
                          contactsData[contactCtrl!.get('id')!.value]
                            .contactPrivacy?.unsubscribed
                        "
                      >
                        {{ "Unsubscribed" | translate }}
                      </span>
                    </div>
                    <div
                      *ngIf="
                        contactsData[contactCtrl!.get('id')!.value].contactTags
                          ?.length
                      "
                      class="row"
                    >
                      <strong>{{ "Tags" | translate }}</strong>
                      <mat-icon
                        (mouseout)="tagsPopoverVisibility = false"
                        (mouseover)="tagsPopoverVisibility = true"
                        style="font-size: large; text-align: right"
                      >
                        remove_red_eye
                      </mat-icon>
                      <div
                        *ngIf="tagsPopoverVisibility"
                        class="popover dws-elevation-z16"
                      >
                        <div
                          *ngFor="
                            let tag of contactsData[
                              contactCtrl!.get('id')!.value
                            ].contactTags
                          "
                          class="tag"
                        >
                          {{ tag.tag.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="add-participant">
              <ws-button (click)="addParticipant()" *ngIf="hasClientAssocieted(masterContactControl?.get('id')?.value)"
              style="padding:0; margin:0;" [callToActionType]="'primary'">
              <mat-icon>add</mat-icon>
              {{ "Add participant" | translate }}
            </ws-button>
            </div>
            

          </div>
        </div>
      </div>
      <div class="ws-popup-footer actions-footer">
        <ws-button
          [callToActionType]="'danger'"
          [disabled]="saveDisabled"
          (click)="cancelClicked()"
        >
          {{ "Cancel" | translate }}
        </ws-button>
        <ws-button
          [callToActionType]="'tertiary'"
          *ngIf="isDraftable && !saveDisabled"
          [disabled]="saveDisabled"
          (click)="saveDraftClicked()"
        >
          {{ "Save Draft" | translate }}
        </ws-button>
        <ws-button
          [callToActionType]="'primary'"
          *ngIf="reservation?.state !== 'draft'"
          [disabled]="saveDisabled"
          (click)="saveClicked()"
        >
          {{ (saveDisabled ? "Wait" : "Save") | translate }}
        </ws-button>
      </div>
    </div>

    <mat-datepicker
      #monthpicker
      (monthSelected)="monthSelected($event)"
      *ngIf="!useEventDatePicker"
      startView="year"
    >
    </mat-datepicker>

    <mat-datepicker
      #datepicker
      *ngIf="!useEventDatePicker"
      [calendarHeaderComponent]="
        ('reservation-boundless-datetime' | on) ? undefined : emptyHeader
      "
    >
    </mat-datepicker>
  </mat-sidenav-content>
</mat-sidenav-container>
